<script setup lang="ts">
import { ICONS } from '~ds/lib/icons';
import KUICoreButtonIcon from '~kui/components/KUI/Core/Button/Icon/KUICoreButtonIcon.vue';

interface Props {
  inline?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  inline: false,
});

defineEmits<{
  close: [];
}>();

const positionClasses = computed(() =>
  twMerge(
    cva('', {
      variants: {
        inline: {
          true: '',
          false: 'absolute top-2 right-2 z-50',
        },
      },
    })({
      inline: props.inline,
    }),
  ),
);
</script>

<template>
  <KUICoreButtonIcon
    :icon="ICONS.cancel"
    size="sm"
    variant="white"
    :aria-label="$t('unified.common.close')"
    :class="positionClasses"
    @click="$emit('close')"
  />
</template>
